module.exports = __webpack_public_path__ + "img/shell.2c928cc9.png";